import React from 'react';

import { cn } from './cn';

export interface FooterProps {
  copyrightText?: string;
  onPrivacyPolicyClick?: () => void;
  onCookiePreferencesClick?: () => void;
  className?: string;
}

export const Footer = React.forwardRef<HTMLElement, FooterProps>(
  (
    {
      copyrightText = `© ${new Date().getFullYear()} H2O.ai. All rights reserved.`,
      onPrivacyPolicyClick,
      onCookiePreferencesClick,
      className,
    },
    ref
  ) => {
    return (
      <footer
        ref={ref}
        className={cn(
          'flex flex-col items-center justify-center gap-1.5 border-t border-border bg-surface-raised py-4 text-center',
          className
        )}
        data-test="footer"
      >
        <span className="type-caption text-text-secondary tracking-wide">{copyrightText}</span>
        {(onPrivacyPolicyClick || onCookiePreferencesClick) && (
          <div className="flex items-center gap-3">
            {onPrivacyPolicyClick && (
              <button
                type="button"
                onClick={onPrivacyPolicyClick}
                className="type-caption text-text-link underline-offset-4 hover:underline cursor-pointer bg-transparent border-none p-0 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring rounded-sm"
              >
                Privacy Policy
              </button>
            )}
            {onPrivacyPolicyClick && onCookiePreferencesClick && (
              <span className="type-caption text-text-disabled" aria-hidden="true">
                ·
              </span>
            )}
            {onCookiePreferencesClick && (
              <button
                type="button"
                onClick={onCookiePreferencesClick}
                className="type-caption text-text-link underline-offset-4 hover:underline cursor-pointer bg-transparent border-none p-0 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring rounded-sm"
              >
                Cookie Preferences
              </button>
            )}
          </div>
        )}
      </footer>
    );
  }
);

Footer.displayName = 'Footer';
